import Vue from 'vue';
import store from './../../store';
import productPackagingTransformer from './../../transformers/productPackaging';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const productPackagings = productPackagingTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedProductPackagings', { productPackagings, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('product_packagings', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productPackaging/items.js